import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { gql } from 'graphql-request';
import type { SWRConfiguration } from 'swr';

import { InvalidTokenError } from '@repo/ui/src/utils/errors';
import { GraphQLRequestWithTokenProps, requestWithTokenRequired } from '@utils/graphql-request';
import useSWRImmutable from 'swr/immutable';
import { useCustomerIdToken } from './useCustomer';

export const PreferencesFragment = gql`
  fragment Preferences on User {
    emailSubscribed
    smsSubscribed
  }
`;

const GET_PREFERENCES = gql`
  ${PreferencesFragment}
  query GetPreferences {
    getSelf {
      ...Preferences
    }
  }
`;

interface Preferences {
  emailSubscribed?: boolean;
  smsSubscribed?: boolean;
}

const fetcher = async (props: GraphQLRequestWithTokenProps) => {
  try {
    const data = await requestWithTokenRequired(props);
    if (!data) {
      return;
    }
    return data.getSelf as Preferences;
  } catch {
    throw new InvalidTokenError();
  }
};

export const useCustomerPreferences = (config: SWRConfiguration = {}) => {
  const { locale } = useCurrentUrl();
  const idToken = useCustomerIdToken();

  return useSWRImmutable<Preferences | undefined>(
    { document: GET_PREFERENCES, locale, idToken },
    fetcher,
    {
      shouldRetryOnError: false,
      ...config,
    },
  );
};
